module.exports = __webpack_public_path__ + "static/media/0262_Medium.393da349.jpg";